import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "l-the-footer" }
const _hoisted_2 = { class: "tlpf-languages" }
const _hoisted_3 = { class: "p-the-footer" }
const _hoisted_4 = { class: "c-common-inner" }
const _hoisted_5 = {
  key: 0,
  class: "p-the-footer__content"
}
const _hoisted_6 = { class: "p-the-footer__left" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "p-the-footer__site_id" }
const _hoisted_11 = { class: "p-the-footer__right" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "p-the-footer__contact"
}
const _hoisted_15 = { "data-translate-skip": "" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 1,
  class: "p-the-footer__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("i", null, [
        _createElementVNode("img", {
          src: "https://bs.benefit-one.inc/contents/img/ats/icon_global-outlined.svg",
          alt: "",
          width: "28",
          height: "28"
        })
      ], -1)),
      _createElementVNode("span", {
        class: _normalizeClass(["tlpf-switch", { selected: _ctx.activeLang === 'ja' }]),
        "data-value": "ja",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeLang !== 'ja' && _ctx.switchLang('ja')))
      }, "日本語", 2),
      _cache[3] || (_cache[3] = _createElementVNode("span", null, "|", -1)),
      _createElementVNode("span", {
        class: _normalizeClass(["tlpf-switch", { selected: _ctx.activeLang === 'en' }]),
        "data-value": "en",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeLang !== 'en' && _ctx.switchLang('en')))
      }, "English", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["p-the-footer__inner", {
            'p-the-footer__inner--not_login': !_ctx.footers.site_id
          }])
        }, [
          (
              _ctx.footers.site_id &&
                _ctx.checkSelectContractFlag === null &&
                _ctx.checkExpiredContractDate === null &&
                _ctx.checkNotContractedIc === null &&
                !_ctx.footer_hidden_flag
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    href: _ctx.urls.whitePaper,
                    class: "p-the-footer__link",
                    target: "_blank"
                  }, "ホワイトペーパー", 8, _hoisted_7),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    style: {"display":"inline-block","margin-top":"20px"},
                    href: _ctx.urls.travelAgencyLaw,
                    class: "p-the-footer__link",
                    target: "_blank"
                  }, "旅行業法に基づく営業所の表示", 8, _hoisted_8),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    style: {"display":"inline-block","margin-top":"20px"},
                    href: _ctx.urls.privacyPolicy,
                    target: "_blank",
                    class: "p-the-footer__link"
                  }, "プライバシーポリシー", 8, _hoisted_9),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "p-the-footer__maintenance" }, [
                    _createElementVNode("p", null, "システムメンテナンス"),
                    _createElementVNode("p", null, " AM2:00～5:00の時間内は、メンテナンスのためご利用いただけません。 ")
                  ], -1)),
                  _createElementVNode("p", _hoisted_10, " サイトID " + _toDisplayString(_ctx.footers.site_id), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", {
                    style: {"display":"inline-block"},
                    href: _ctx.termsUrl,
                    target: "_blank",
                    class: "p-the-footer__link"
                  }, "利用規約", 8, _hoisted_12),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    href: _ctx.urls.enquiryLink,
                    class: "p-the-footer__link",
                    style: {"margin-top":"20px"}
                  }, "商品に関するお問い合わせ", 8, _hoisted_13),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  (_ctx.displayDepartmentName || _ctx.displayEmail || _ctx.displayTel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "p-the-footer__link" }, " 商品以外に関するお問い合わせ先 ", -1)),
                        _createElementVNode("div", _hoisted_15, [
                          (_ctx.displayDepartmentName)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.footers.department_name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.displayEmail)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.footers.email_address), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.displayTel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.footers.telephone_number), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (!_ctx.footer_hidden_flag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[10] || (_cache[10] = [
                  _createElementVNode("div", { class: "p-the-footer__maintenance" }, [
                    _createElementVNode("p", null, "システムメンテナンス"),
                    _createElementVNode("p", null, " AM2:00～5:00の時間内は、メンテナンスのためご利用いただけません。 ")
                  ], -1)
                ])))
              : _createCommentVNode("", true),
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "p-the-footer__copyright" }, " Copyright(C) 2020 Benefit-one Inc. All rights reserved ", -1))
        ], 2)
      ])
    ])
  ]))
}